package fyi.moko.hotpl.domain.photo

/** 이미지 라벨 하나와 그 신뢰도. */
data class LabelScore(val label: String, val confidence: Float)

/**
 * 사진 한 장에서 뽑아낸 온디바이스 신호. 어떻게 뽑는지는 플랫폼이 정하고
 * ([PhotoSignalExtractor]), 이 값을 [PhotoKindGuess]로 옮기는 규칙은 공통이다.
 *
 * [textBlocks]가 글자 **수**가 아니라 블록 수인 이유: 메뉴판을 가르는 건 글자의 유무가 아니라
 * 밀도이고, 실측에서 블록 수가 가장 깨끗하게 갈렸다 — 메뉴판 15~76블록, 나머지 38장 전부
 * 0~7블록. 간판 글자가 큼직한 외관 사진도 7블록을 넘지 않았다.
 */
data class PhotoSignals(
    val labels: List<LabelScore>,
    val textBlocks: Int,
)
